export enum ClaimTypeCode {
    pha = 'pha',
    med = 'med',
}
